const EventCardData = [

  {
    id: 30,
    imgsrc: "https://yugalkunj.org/images/Ganesh_Chaturth.png",
    title: "Ganesh Chaturthi Satsang & Celebrations",
    lablename: "Read More",
    links: "/USA/GaneshChaturthi",
    pagelinks: "/USA/GaneshChaturthi",
    enddate: "14/09/2026",
    imglinks: "https://yugalkunj.org/images/Ganesh_Chaturth.png"
  },

  {
    id: 31,
    imgsrc: "https://yugalkunj.org/images/Radhashtami.png",
    title: "Radhashtami Satsang & Celebrations",
    lablename: "Read More",
    links: "/USA/Radhashtami",
    pagelinks: "/USA/Radhashtami",
    enddate: "19/09/2026",
    imglinks: "https://yugalkunj.org/images/Radhashtami.png"
  },

  {
    id: 1,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/ad6af72c_janmashtami_Mahotsav.png",
    title: "Grand Janmashtami Celebrations",
    lablename: "View Details",
    links: "/USA/Janmashtami",
    pagelinks: "/USA/Janmashtami",
    enddate: "05/09/2026",
    imglinks: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/ad6af72c_janmashtami_Mahotsav.png"
  },

  {
    id: 2,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/97153409_11-Anniversary.png",
    title: "11th Anniversary Celebration - Musical Night",
    titleHtml: "11<sup>th</sup> Anniversary Celebration – Musical Night",
    lablename: "View Details",
    links: "/USA/Anniversary11th",
    pagelinks: "/USA/Anniversary11th",
    enddate: "05/09/2026",
    imglinks: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/97153409_11-Anniversary.png"
  },

  {
    id: 21,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png",
    title: "Janmashtami Parking & Map Guide",
    lablename: "View Flyer",
    links: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png",
    pagelinks: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png",
    enddate: "05/09/2026",
    imglinks: "https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png"
  },

{
    id: 3,
    imgsrc: "https://yugalkunj.org/images/Gurukul-2026-27-v3.png",
    title: "Gurukul Classes ",
    lablename: "View Flyer",
    links: "https://portalyk.yugalkunj.org/",
    pagelinks: "https://portalyk.yugalkunj.org/",
    enddate: "10/05/2027",
    imglinks: "https://stssevastorage.blob.core.windows.net/my-container/Gurukul-2026-27-v3.png"
  },

  {
    id: 3,
    imgsrc: "https://yugalkunj.org/images/swaminikhaland%20.jpeg",
    title: "Lecture Series by Swami Nikhilanand Ji",
    lablename: "View Flyer",
    links: "https://yugalkunj.org/images/swaminikhaland%20.jpeg",
    pagelinks: "https://yugalkunj.org/images/swaminikhaland%20.jpeg",
    enddate: "22/06/2026",
    imglinks: "https://yugalkunj.org/images/swaminikhaland%20.jpeg"
  },

  {
    id: 4,
    imgsrc: "https://yugalkunj.org/images/hariyali_teej_2026.png",
    title: "Hariyali Teej Satsang",
    lablename: "View Flyer",
    links: "https://yugalkunj.org/images/hariyali_teej_2026.png",
    pagelinks: "https://yugalkunj.org/images/hariyali_teej_2026.png",
    enddate: "16/08/2026",
    imglinks: "https://yugalkunj.org/images/hariyali_teej_2026.png"
  },


  {
    id: 5,
    imgsrc: "https://yugalkunj.org/images/rakhshabandhan_2026.png",
    title: "Raksha Bandhan Satsang",
    lablename: "View Flyer",
    links: "https://yugalkunj.org/images/rakhshabandhan_2026.png",
    pagelinks: "https://yugalkunj.org/images/rakhshabandhan_2026.png",
    enddate: "29/08/2026",
    imglinks: "https://yugalkunj.org/images/rakhshabandhan_2026.png"
  },

  {
    id: 6,
    imgsrc: "https://yugalkunj.org/images/dushehra-2026.jpeg",
    title: "Dushehra celebration",
    lablename: "View Flyer",
    links: "https://yugalkunj.org/images/dushehra-2026.jpeg",
    pagelinks: "https://yugalkunj.org/images/dushehra-2026.jpeg",
    enddate: "21/10/2026",
    imglinks: "https://yugalkunj.org/images/dushehra-2026.jpeg"
  },

  {
    id: 7,
    imgsrc: "https://stssevastorage.blob.core.windows.net/media/hyc/events/image/1/a589b86f_Fall_Festival.jpeg",
    title: "Fall Festival 2026",
    lablename: "Read More",
    links: "/USA/FallFestival",
    pagelinks: "/USA/FallFestival",
    enddate: "25/09/2026",
    imglinks: "https://stssevastorage.blob.core.windows.net/media/hyc/events/image/1/a589b86f_Fall_Festival.jpeg"
  },

  {
    id: 8,
    imgsrc: "https://yugalkunj.org/images/classical_musice-20-27.png",
    title: "Carnatic Classical Music",
    lablename: "Register Now",
    links: "https://portalyk.yugalkunj.org/",
    pagelinks: "https://portalyk.yugalkunj.org/",
    enddate: "23/11/2026",
    imglinks: "https://yugalkunj.org/images/classical_musice-20-27.png"
  },

  {
    id: 8,
    imgsrc: "https://yugalkunj.org/images/bharatnatyam_2026-27.png",
    title: "Bharatnatyam Dance classes",
    lablename: "Register Now",
    links: "https://portalyk.yugalkunj.org/",
    pagelinks: "https://portalyk.yugalkunj.org/",
    enddate: "23/11/2026",
    imglinks: "https://yugalkunj.org/images/bharatnatyam_2026-27.png"
  },

  {
    id: 9,
    imgsrc: "https://yugalkunj.org/images/dholak_class_2026.png",
    title: "Dholak Classes",
    lablename: "Register Now",
    links: "https://portalyk.yugalkunj.org/",
    pagelinks: "https://portalyk.yugalkunj.org/",
    enddate: "23/11/2026",
    imglinks: "https://yugalkunj.org/images/dholak_class_2026.png"
  },

  {
    id: 10,
    imgsrc: "https://yugalkunj.org/images/harmonai_vocal_2026-27.png",
    title: "Harmonium & Vocal Classes ",
    lablename: "Register Now",
    links: "https://portalyk.yugalkunj.org/",
    pagelinks: "https://portalyk.yugalkunj.org/",
    enddate: "23/11/2026",
    imglinks: "https://yugalkunj.org/images/harmonai_vocal_2026-27.png"
  },

  {
    id: 11,
    imgsrc: "https://stssevastorage.blob.core.windows.net/ykwebsite/flyer/OrganicGarden.jpeg",
    title: "Join Our Organic Gardening Fun!",
    lablename: "View Flyer",
    links: "https://stssevastorage.blob.core.windows.net/ykwebsite/flyer/OrganicGarden.jpeg",
    pagelinks: "#",
    enddate: "17/08/2030",
    imglinks: "https://stssevastorage.blob.core.windows.net/ykwebsite/flyer/OrganicGarden.jpeg"
  }

];

export default EventCardData;
